// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import flagSA from '../../../assets/img/flagsCountry/flag-SA.png';
// @ts-ignore
import flagSN from '../../../assets/img/flagsCountry/flag-SN.png';
// @ts-ignore
import flagRS from '../../../assets/img/flagsCountry/flag-RS.png';
// @ts-ignore
import flagSC from '../../../assets/img/flagsCountry/flag-SC.png';
// @ts-ignore
import flagSL from '../../../assets/img/flagsCountry/flag-SL.png';
// @ts-ignore
import flagSG from '../../../assets/img/flagsCountry/flag-SG.png';
// @ts-ignore
import flagSK from '../../../assets/img/flagsCountry/flag-SK.png';
// @ts-ignore
import flagSI from '../../../assets/img/flagsCountry/flag-SI.png';
// @ts-ignore
import flagSB from '../../../assets/img/flagsCountry/flag-SB.png';
// @ts-ignore
import flagSO from '../../../assets/img/flagsCountry/flag-SO.png';
// @ts-ignore
import flagZA from '../../../assets/img/flagsCountry/flag-ZA.png';
// @ts-ignore
import flagSS from '../../../assets/img/flagsCountry/flag-SS.png';
// @ts-ignore
import flagES from '../../../assets/img/flagsCountry/flag-ES.png';
// @ts-ignore
import flagLK from '../../../assets/img/flagsCountry/flag-LK.png';
// @ts-ignore
import flagSD from '../../../assets/img/flagsCountry/flag-SD.png';
// @ts-ignore
import flagSR from '../../../assets/img/flagsCountry/flag-SR.png';
// @ts-ignore
import flagSJ from '../../../assets/img/flagsCountry/flag-SJ.png';
// @ts-ignore
import flagSZ from '../../../assets/img/flagsCountry/flag-SZ.png';
// @ts-ignore
import flagSE from '../../../assets/img/flagsCountry/flag-SE.png';
// @ts-ignore
import flagCH from '../../../assets/img/flagsCountry/flag-CH.png';
// @ts-ignore
import flagSY from '../../../assets/img/flagsCountry/flag-SY.png';
// @ts-ignore
import flagTW from '../../../assets/img/flagsCountry/flag-TW.png';
// @ts-ignore
import flagTJ from '../../../assets/img/flagsCountry/flag-TJ.png';
// @ts-ignore
import flagTZ from '../../../assets/img/flagsCountry/flag-TZ.png';
// @ts-ignore
import flagTH from '../../../assets/img/flagsCountry/flag-TH.png';
// @ts-ignore
import flagTL from '../../../assets/img/flagsCountry/flag-TL.png';
// @ts-ignore
import flagTG from '../../../assets/img/flagsCountry/flag-TG.png';
// @ts-ignore
import flagTK from '../../../assets/img/flagsCountry/flag-TK.png';
// @ts-ignore
import flagTO from '../../../assets/img/flagsCountry/flag-TO.png';
// @ts-ignore
import flagTT from '../../../assets/img/flagsCountry/flag-TT.png';
// @ts-ignore
import flagTN from '../../../assets/img/flagsCountry/flag-TN.png';
// @ts-ignore
import flagTR from '../../../assets/img/flagsCountry/flag-TR.png';
// @ts-ignore
import flagTM from '../../../assets/img/flagsCountry/flag-TM.png';
// @ts-ignore
import flagTC from '../../../assets/img/flagsCountry/flag-TC.png';
// @ts-ignore
import flagTV from '../../../assets/img/flagsCountry/flag-TV.png';
// @ts-ignore
import flagUG from '../../../assets/img/flagsCountry/flag-UG.png';
// @ts-ignore
import flagUA from '../../../assets/img/flagsCountry/flag-UA.png';
// @ts-ignore
import flagAE from '../../../assets/img/flagsCountry/flag-AE.png';
// @ts-ignore
import flagGB from '../../../assets/img/flagsCountry/flag-GB.png';
// @ts-ignore
import flagUS from '../../../assets/img/flagsCountry/flag-US.png';
// @ts-ignore
import flagUY from '../../../assets/img/flagsCountry/flag-UY.png';
// @ts-ignore
import flagUZ from '../../../assets/img/flagsCountry/flag-UZ.png';
// @ts-ignore
import flagVU from '../../../assets/img/flagsCountry/flag-VU.png';
// @ts-ignore
import flagVE from '../../../assets/img/flagsCountry/flag-VE.png';
// @ts-ignore
import flagVN from '../../../assets/img/flagsCountry/flag-VN.png';
// @ts-ignore
import flagWF from '../../../assets/img/flagsCountry/flag-WF.png';
// @ts-ignore
import flagYE from '../../../assets/img/flagsCountry/flag-YE.png';
// @ts-ignore
import flagZM from '../../../assets/img/flagsCountry/flag-ZM.png';
// @ts-ignore
import flagZW from '../../../assets/img/flagsCountry/flag-ZW.png';
export const CountriesD = [
    {
        ru: 'Саудовская Аравия',
        lt: 'Saudo Arabija',
        tr: 'Suudi Arabistan',
        en: 'Saudi Arabia',
        flagIcon: '🇸🇦',
        code: 'SA',
        flag: flagSA,
        dialCode: '966',
        mask: '999 999 9999',
    },
    {
        ru: 'Сенегал',
        lt: 'Senegalas',
        tr: 'Senegal',
        en: 'Senegal',
        flagIcon: '🇸🇳',
        code: 'SN',
        flag: flagSN,
        dialCode: '221',
        mask: '99 999 99 99',
    },
    {
        ru: 'Сербия',
        lt: 'Serbija',
        tr: 'Sırbistan',
        en: 'Serbia',
        flagIcon: '🇷🇸',
        code: 'RS',
        flag: flagRS,
        dialCode: '381',
        mask: '999 9999999',
    },
    {
        ru: 'Сейшельские острова',
        lt: 'Seišeliai',
        tr: 'Seyşeller',
        en: 'Seychelles',
        flagIcon: '🇸🇨',
        code: 'SC',
        flag: flagSC,
        dialCode: '248',
        mask: '9 999 999',
    },
    {
        ru: 'Сьерра-Леоне',
        lt: 'Siera Leonė',
        tr: 'Sierra Leone',
        en: 'Sierra Leone',
        flagIcon: '🇸🇱',
        code: 'SL',
        flag: flagSL,
        dialCode: '232',
        mask: '(999) 999999',
    },
    {
        ru: 'Сингапур',
        lt: 'Singapūras',
        tr: 'Singapur',
        en: 'Singapore',
        flagIcon: '🇸🇬',
        code: 'SG',
        flag: flagSG,
        dialCode: '65',
        mask: '9999 9999',
    },
    {
        ru: 'Словакия',
        lt: 'Slovakija',
        tr: 'Slovakya',
        en: 'Slovakia',
        flagIcon: '🇸🇰',
        code: 'SK',
        flag: flagSK,
        dialCode: '421',
        mask: '9999 999 999',
    },
    {
        ru: 'Словения',
        lt: 'Slovėnija',
        tr: 'Slovenya',
        en: 'Slovenia',
        flagIcon: '🇸🇮',
        code: 'SI',
        flag: flagSI,
        dialCode: '386',
        mask: '999 999 999',
    },
    {
        ru: 'Соломоновы острова',
        lt: 'Saliamono salos',
        tr: 'Solomon Adaları',
        en: 'Solomon Islands',
        flagIcon: '🇸🇧',
        code: 'SB',
        flag: flagSB,
        dialCode: '677',
        mask: '99 99999',
    },
    {
        ru: 'Сомали',
        lt: 'Somalis',
        tr: 'Somali',
        en: 'Somalia',
        flagIcon: '🇸🇴',
        code: 'SO',
        flag: flagSO,
        dialCode: '252',
        mask: '9 9999999',
    },
    {
        ru: 'Южная Африка',
        lt: 'pietų Afrika',
        tr: 'Güney Afrika',
        en: 'South Africa',
        flagIcon: '🇿🇦',
        code: 'ZA',
        flag: flagZA,
        dialCode: '27',
        mask: '999 999 9999',
    },
    {
        ru: 'южный Судан',
        lt: 'Pietų Sudanas',
        tr: 'Güney Sudan',
        en: 'South Sudan',
        flagIcon: '🇸🇸',
        code: 'SS',
        flag: flagSS,
        dialCode: '211',
        mask: '9999 999 999',
    },
    {
        ru: 'Испания',
        lt: 'Ispanija',
        tr: 'ispanya',
        en: 'Spain',
        flagIcon: '🇪🇸',
        code: 'ES',
        flag: flagES,
        dialCode: '34',
        mask: '999 99 99 99',
    },
    {
        ru: 'Шри-Ланка',
        lt: 'Šri Lanka',
        tr: 'Sri Lanka',
        en: 'Sri Lanka',
        flagIcon: '🇱🇰',
        code: 'LK',
        flag: flagLK,
        dialCode: '94',
        mask: '999 999 9999',
    },
    {
        ru: 'Судан',
        lt: 'Sudanas',
        tr: 'Sudan',
        en: 'Sudan',
        flagIcon: '🇸🇩',
        code: 'SD',
        flag: flagSD,
        dialCode: '249',
        mask: '999 999 9999',
    },
    {
        ru: 'Суринам',
        lt: 'Surinamas',
        tr: 'Surinam',
        en: 'Suriname',
        flagIcon: '🇸🇷',
        code: 'SR',
        flag: flagSR,
        dialCode: '597',
        mask: '999-9999',
    },
    {
        ru: 'Шпицберген и Ян Майен',
        lt: 'Svalbardas ir Janas Mayenas',
        tr: 'Svalbard ve Jan Mayen',
        en: 'Svalbard and Jan Mayen',
        flagIcon: '🇸🇯',
        code: 'SJ',
        flag: flagSJ,
        dialCode: '47',
        mask: '999 99 999',
    },
    {
        ru: 'Свазиленд',
        lt: 'Svazilandas',
        tr: 'Svaziland',
        en: 'Swaziland',
        flagIcon: '🇸🇿',
        code: 'SZ',
        flag: flagSZ,
        dialCode: '268',
        mask: '9999 9999',
    },
    {
        ru: 'Швеция',
        lt: 'Švedija',
        tr: 'İsveç',
        en: 'Sweden',
        flagIcon: '🇸🇪',
        code: 'SE',
        flag: flagSE,
        dialCode: '46',
        mask: '999-999 99 99',
    },
    {
        ru: 'Швейцария',
        lt: 'Šveicarija',
        tr: 'İsviçre',
        en: 'Switzerland',
        flagIcon: '🇨🇭',
        code: 'CH',
        flag: flagCH,
        dialCode: '41',
        mask: '999 999 99 99',
    },
    {
        ru: 'Сирийская Арабская Республика',
        lt: 'Sirijos Arabų Respublika',
        tr: 'Suriye Arap Cumhuriyeti',
        en: 'Syrian Arab Republic',
        flagIcon: '🇸🇾',
        code: 'SY',
        flag: flagSY,
        dialCode: '963',
        mask: '9999 999 999',
    },
    {
        ru: 'Тайвань',
        lt: 'Taivanas',
        tr: 'Tayvan',
        en: 'Taiwan',
        flagIcon: '🇹🇼',
        code: 'TW',
        flag: flagTW,
        dialCode: '886',
        mask: '9999 999 999',
    },
    {
        ru: 'Таджикистан',
        lt: 'Tadžikistanas',
        tr: 'Tacikistan',
        en: 'Tajikistan',
        flagIcon: '🇹🇯',
        code: 'TJ',
        flag: flagTJ,
        dialCode: '992',
        mask: '999 99 9999',
    },
    {
        ru: 'Танзания, Объединенная Республика Танзания',
        lt: 'Tanzanija, Jungtinė Tanzanijos Respublika',
        tr: 'Tanzanya, Tanzanya Birleşik Cumhuriyeti',
        en: 'Tanzania, United Republic of Tanzania',
        flagIcon: '🇹🇿',
        code: 'TZ',
        flag: flagTZ,
        dialCode: '255',
        mask: '9999 999 999',
    },
    {
        ru: 'Таиланд',
        lt: 'Tailandas',
        tr: 'Tayland',
        en: 'Thailand',
        flagIcon: '🇹🇭',
        code: 'TH',
        flag: flagTH,
        dialCode: '66',
        mask: '999 999 9999',
    },
    {
        ru: 'Восточный Тимор',
        lt: 'Timoras-Leste',
        tr: 'Timor-Leste',
        en: 'Timor-Leste',
        flagIcon: '🇹🇱',
        code: 'TL',
        flag: flagTL,
        dialCode: '670',
        mask: '9999 9999',
    },
    {
        ru: 'Идти',
        lt: 'Eiti',
        tr: 'Gitmek',
        en: 'Togo',
        flagIcon: '🇹🇬',
        code: 'TG',
        flag: flagTG,
        dialCode: '228',
        mask: '99 99 99 99',
    },
    {
        ru: 'Токелау',
        lt: 'Tokelau',
        tr: 'Tokelau',
        en: 'Tokelau',
        flagIcon: '🇹🇰',
        code: 'TK',
        flag: flagTK,
        dialCode: '690',
        mask: '9999',
    },
    {
        ru: 'Тонга',
        lt: 'Tonga',
        tr: 'Tonga',
        en: 'Tonga',
        flagIcon: '🇹🇴',
        code: 'TO',
        flag: flagTO,
        dialCode: '676',
        mask: '999 9999',
    },
    {
        ru: 'Тринидад и Тобаго',
        lt: 'Trinidadas ir Tobagas',
        tr: 'Trinidad ve Tobago',
        en: 'Trinidad and Tobago',
        flagIcon: '🇹🇹',
        code: 'TT',
        flag: flagTT,
        dialCode: '1868',
        mask: '(999) 999-9999',
    },
    {
        ru: 'Тунис',
        lt: 'Tunisas',
        tr: 'Tunus',
        en: 'Tunisia',
        flagIcon: '🇹🇳',
        code: 'TN',
        flag: flagTN,
        dialCode: '216',
        mask: '99 999 999',
    },
    {
        ru: 'индейка',
        lt: 'Turkija',
        tr: 'Türkiye',
        en: 'Turkey',
        flagIcon: '🇹🇷',
        code: 'TR',
        flag: flagTR,
        dialCode: '90',
        mask: '(999) 999 9999',
    },
    {
        ru: 'Туркменистан',
        lt: 'Turkmėnistanas',
        tr: 'Türkmenistan',
        en: 'Turkmenistan',
        flagIcon: '🇹🇲',
        code: 'TM',
        flag: flagTM,
        dialCode: '993',
        mask: '9 99 999999',
    },
    {
        ru: 'Острова Теркс и Кайкос',
        lt: 'Terkso ir Kaikoso salos',
        tr: 'Turks ve Caicos Adaları',
        en: 'Turks and Caicos Islands',
        flagIcon: '🇹🇨',
        code: 'TC',
        flag: flagTC,
        dialCode: '1649',
        mask: '(999) 999-9999',
    },
    {
        ru: 'Тувалу',
        lt: 'Tuvalu',
        tr: 'Tuvalu',
        en: 'Tuvalu',
        flagIcon: '🇹🇻',
        code: 'TV',
        flag: flagTV,
        dialCode: '688',
        mask: '999999',
    },
    {
        ru: 'Уганда',
        lt: 'Uganda',
        tr: 'Uganda',
        en: 'Uganda',
        flagIcon: '🇺🇬',
        code: 'UG',
        flag: flagUG,
        dialCode: '256',
        mask: '9999 999999',
    },
    {
        ru: 'Украина',
        lt: 'Ukraina',
        tr: 'Ukrayna',
        en: 'Ukraine',
        flagIcon: '🇺🇦',
        code: 'UA',
        flag: flagUA,
        dialCode: '380',
        mask: '999 999 9999',
    },
    {
        ru: 'Объединенные Арабские Эмираты',
        lt: 'Jungtiniai Arabų Emyratai',
        tr: 'Birleşik Arap Emirlikleri',
        en: 'United Arab Emirates',
        flagIcon: '🇦🇪',
        code: 'AE',
        flag: flagAE,
        dialCode: '971',
        mask: '999 999 9999',
    },
    {
        ru: 'объединенное Королевство',
        lt: 'Jungtinė Karalystė',
        tr: 'Birleşik Krallık',
        en: 'United Kingdom',
        flagIcon: '🇬🇧',
        code: 'GB',
        flag: flagGB,
        dialCode: '44',
        mask: '99999 999999',
    },
    {
        ru: 'Соединенные Штаты',
        lt: 'Jungtinės Valstijos',
        tr: 'Amerika Birleşik Devletleri',
        en: 'United States',
        flagIcon: '🇺🇸',
        code: 'US',
        flag: flagUS,
        dialCode: '1',
        mask: '(999) 999-9999',
    },
    {
        ru: 'Уругвай',
        lt: 'Urugvajus',
        tr: 'Uruguay',
        en: 'Uruguay',
        flagIcon: '🇺🇾',
        code: 'UY',
        flag: flagUY,
        dialCode: '598',
        mask: '999 999 999',
    },
    {
        ru: 'Узбекистан',
        lt: 'Uzbekistanas',
        tr: 'Özbekistan',
        en: 'Uzbekistan',
        flagIcon: '🇺🇿',
        code: 'UZ',
        flag: flagUZ,
        dialCode: '998',
        mask: '9 99 999 99 99',
    },
    {
        ru: 'Вануату',
        lt: 'Vanuatu',
        tr: 'Vanuatu',
        en: 'Vanuatu',
        flagIcon: '🇻🇺',
        code: 'VU',
        flag: flagVU,
        dialCode: '678',
        mask: '999 9999',
    },
    {
        ru: 'Венесуэла, Боливарианская Республика Венесуэла',
        lt: 'Venesuela, Venesuelos Bolivaro Respublika',
        tr: 'Venezuela, Bolivarcı Venezuela Cumhuriyeti',
        en: 'Venezuela, Bolivarian Republic of Venezuela',
        flagIcon: '🇻🇪',
        code: 'VE',
        flag: flagVE,
        dialCode: '58',
        mask: '9999-9999999',
    },
    {
        ru: 'Вьетнам',
        lt: 'Vietnamas',
        tr: 'Vietnam',
        en: 'Vietnam',
        flagIcon: '🇻🇳',
        code: 'VN',
        flag: flagVN,
        dialCode: '84',
        mask: '999 999 99 99',
    },
    {
        ru: 'Уоллис и Футуна',
        lt: 'Volis ir Futuna',
        tr: 'Wallis ve Futuna',
        en: 'Wallis and Futuna',
        flagIcon: '🇼🇫',
        code: 'WF',
        flag: flagWF,
        dialCode: '681',
        mask: '99 99 99',
    },
    {
        ru: 'Йемен',
        lt: 'Jemenas',
        tr: 'Yemen',
        en: 'Yemen',
        flagIcon: '🇾🇪',
        code: 'YE',
        flag: flagYE,
        dialCode: '967',
        mask: '999 999 999',
    },
    {
        ru: 'Замбия',
        lt: 'Zambija',
        tr: 'Zambiya',
        en: 'Zambia',
        flagIcon: '🇿🇲',
        code: 'ZM',
        flag: flagZM,
        dialCode: '260',
        mask: '999 9999999',
    },
    {
        ru: 'Zimbabve',
        lt: 'Zimbabvė',
        tr: 'Zimbabve',
        en: 'Zimbabwe',
        flagIcon: '🇿🇼',
        code: 'ZW',
        flag: flagZW,
        dialCode: '263',
        mask: '999 999 9999',
    },
];
export default CountriesD;
